module.exports = __webpack_public_path__ + "4c4a6915b28fe388d6e56fff33bff175.svg";